module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/5_a86a89546036377607912456a625a8c7.jpg";